/* tslint:disable:no-trailing-whitespace */
import {DoraProperty} from '../../../Decorators/Decorator';
import {DateRange} from '../../../Utility/date-range';

export enum SERIES_SELECTOR_TYPE {
  INTRADAY,
  HISTORICAL,
  CORRECTION,
  DIVIDEND
}


export class SeriesSelectorType {

  @DoraProperty
  private type  = '';

  // tslint:disable-next-line:variable-name
  private _dateRange: DateRange;

  // tslint:disable-next-line:variable-name
  private _description = '';

  // tslint:disable-next-line:variable-name
  private _selected = false;

  constructor(type = '') {
    this.type = type;
  }

  set selected(value: boolean) {
    this._selected = value;
  }

  get selected(): boolean {
    return this._selected;
  }

  get description(): string {
    if (this._description === '') {
      return this.type;
    } else {
      return this._description;
    }
  }

  public setType(value: string): void {
    this.type = value;
  }
  public get Type(): SERIES_SELECTOR_TYPE {
    return SERIES_SELECTOR_TYPE[this.type];
  }

  get dateRange(): DateRange {
    return this._dateRange;
  }

  set dateRange(value: DateRange) {
    this._dateRange = value;
  }

  public setDay(day: number): void {
    const to = new Date();
    // tslint:disable-next-line:no-shadowed-variable
    const from = new Date();

    from.setDate(from.getDate() - day);

    this._dateRange = new DateRange(from, to);
    this._description = 'EXT_' + day + 'D';
  }

  public setMonth(month: number): void {
    const to = new Date();
    // tslint:disable-next-line:no-shadowed-variable
    const from = new Date();

    from.setMonth(from.getMonth() - month);

    this._dateRange = new DateRange(from, to);
    this._description = 'EXT_' + month + 'M';
  }

  public setYear(year: number): void {
    const to = new Date();
    // tslint:disable-next-line:no-shadowed-variable
    const from = new Date();

    from.setFullYear(from.getFullYear() - year);

    this._dateRange = new DateRange(from, to);
    this._description = 'EXT_' + year + 'Y';
  }

  public setStartOfYear(): void {
    const to = new Date();
    // tslint:disable-next-line:no-shadowed-variable
    const from = new Date();

    from.setDate(1);
    from.setMonth(0);

    this._dateRange = new DateRange(from, to);
    this._description = 'EXT_BEG_Y';
  }
}
